import { Component, EventEmitter , CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA} from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ActivatedRoute, Router, RouterModule } from "@angular/router";
import { LatestUpdate } from "../../models/latestupdate";
import { DisableItemsFilterPipe } from "../../pipes/disableitemsfilter.pipe";
import { EmitterService } from "../../services/emitter.service";
import { IButton } from "../../interfaces/ibuttons";
import { HeaderComponent } from "../header/header.component";

@Component({
    selector: "latestupdates",
    standalone: true,
    imports: [CommonModule, FormsModule, RouterModule, HeaderComponent],
    providers: [DisableItemsFilterPipe],
    templateUrl: "./latestupdates.component.html",
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class LatestUpdatesComponent {
    latestUpdates: LatestUpdate[];
    allLatestUpdates: LatestUpdate[];
    hideDisableUpdates: boolean = true;
    headerButtons: IButton[];

    constructor(private togglePipe: DisableItemsFilterPipe, private activatedRoute: ActivatedRoute, private router: Router) {
        this.allLatestUpdates = this.activatedRoute.snapshot.data["latestupdates"] as LatestUpdate[];
        this.latestUpdates = this.allLatestUpdates.filter(u => !u.disabled);
        let emitter: EventEmitter<any> = EmitterService.get("Create update");
        let button: IButton = { label: "Create update", btnClass: "fa fa-plus ml-2", btnClicked: emitter, disable: false };
        this.headerButtons = [button];

        emitter.subscribe(() => { this.addClicked(); });

    }

    addClicked(): void {
        this.router.navigate(["/latestupdate"]);
    }

    editClicked(update: LatestUpdate): void {
        this.router.navigate(["/latestupdate", update.id]);
    }

    /*
    * Show or hide the disabled latest updates.
    */
    showHideDisableUpdates(): void {
        this.hideDisableUpdates = !this.hideDisableUpdates;
        this.latestUpdates = this.togglePipe.transform(this.hideDisableUpdates, this.allLatestUpdates) as LatestUpdate[];
    }
}
